import { Home, Swords, MapPin, User, GraduationCap } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { icon: Home, label: 'Trang chủ', path: '/' },
  { icon: Swords, label: 'Trận đấu', path: '/matches' },
  { icon: MapPin, label: 'Sân', path: '/courts' },
  { icon: GraduationCap, label: 'Lớp học', path: '/classes' },
  { icon: User, label: 'Hồ sơ', path: '/profile' },
];

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-lg border-t border-accent/20">
      <div className="flex items-center justify-around py-1 pb-[max(0.375rem,env(safe-area-inset-bottom))]">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                'relative flex flex-col items-center gap-0.5 px-4 py-2 transition-all duration-200',
                isActive 
                  ? 'text-accent' 
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              {/* Active indicator glow */}
              {isActive && (
                <div className="absolute -top-px left-1/2 -translate-x-1/2 w-8 h-0.5 bg-accent rounded-full" style={{ boxShadow: 'var(--shadow-neon)' }} />
              )}
              <item.icon 
                className={cn(
                  "w-5 h-5 transition-all",
                  isActive && "drop-shadow-[0_0_8px_hsl(var(--accent))]"
                )} 
                strokeWidth={isActive ? 2.5 : 1.5} 
              />
              <span className={cn(
                "text-[10px] font-medium",
                isActive && "text-accent"
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
